import Afro from "./head/Afro";
import Bangs from "./head/Bangs";
import Bangs2 from "./head/Bangs2";
import BantuKnots from "./head/BantuKnots";
import Bear from "./head/Bear";
import Bun from "./head/Bun";
import Bunn from "./head/Bunn";
import Bun2 from "./head/Bun2";
import Buns from "./head/Buns";
import Cornrows from "./head/Cornrows";
import Cornrows2 from "./head/Cornrows2";
// import Dreads from "./head/Dreads";
// import Dreads2 from "./head/Dreads2";
import FlatTop from "./head/FlatTop";
import FlatTopLong from "./head/FlatTopLong";
import GrayBun from "./head/GrayBun";
import GrayMedium from "./head/GrayMedium";
import GrayShort from "./head/GrayShort";
import HatBeanie from "./head/HatBeanie";
import HatHip from "./head/HatHip";
import Hijab from "./head/Hijab";
import Long from "./head/Long";
// import LongAfro from "./head/LongAfro";
// import LongBangs from "./head/LongBangs";
// import LongCurly from "./head/LongCurly";
// import Medium1 from "./head/Medium1";
// import Medium2 from "./head/Medium2";
// import Medium3 from "./head/Medium3";
// import MediumBangs from "./head/MediumBangs";
// import MediumBangs2 from "./head/MediumBangs2";
// import MediumBangs3 from "./head/MediumBangs3";
// import MediumStraight from "./head/MediumStraight";
import Mohawk from "./head/Mohawk";
// import Mohawk2 from "./head/Mohawk2";
// import NoHair1 from "./head/NoHair1";
// import NoHair2 from "./head/NoHair2";
// import NoHair3 from "./head/NoHair3";
import Pomp from "./head/Pomp";
// import Shaved1 from "./head/Shaved1";
// import Shaved2 from "./head/Shaved2";
// import Shaved3 from "./head/Shaved3";
// import Short1 from "./head/Short1";
// import Short2 from "./head/Short2";
// import Short3 from "./head/Short3";
// import Short4 from "./head/Short4";
// import Shortt4 from "./head/Shortt4";
// import Short5 from "./head/Short5";
import Turban from "./head/Turban";
import Twists from "./head/Twists";
// import Twists2 from "./head/Twists2";

import NoneAccessory from "./accessories/None";
import Eyepatch from "./accessories/Eyepatch";
import Glasses from "./accessories/Glasses";
import Glasses2 from "./accessories/Glasses2";
import Glasses3 from "./accessories/Glasses3";
import Glasses4 from "./accessories/Glasses4";
import Glasses5 from "./accessories/Glasses5";
import Sunglasses from "./accessories/Sunglasses";
import Sunglasses2 from "./accessories/Sunglasses2";

import BlazerBlackTee from "./body/BlazerBlackTee";
import ButtonShirt1 from "./body/ButtonShirt1";
import ButtonShirt2 from "./body/ButtonShirt2";
import Coffee from "./body/Coffee";
import Device from "./body/Device";
import Dress from "./body/Dress";
import Dress1 from "./body/Dress1";
import Explaining from "./body/Explaining";
import Gaming from "./body/Gaming";
import GymShirt from "./body/Gym Shirt";
import Hoodie from "./body/Hoodie";
import Jacket from "./body/Jacket";
import JacketPolkaDots from "./body/JacketPolkaDots";
import Killer from "./body/Killer";
import Macbook from "./body/Macbook";
import Paper from "./body/Paper";
import PointingUp from "./body/PointingUp";
import PoloAndSweater from "./body/PoloAndSweater";
import ShirtAndCoat from "./body/ShirtAndCoat";
import SportyTee from "./body/SportyTee";
import StripedPocketTee from "./body/StripedPocketTee";
import StripedTee from "./body/StripedTee";
import Sweater from "./body/Sweater";
import SweaterDots from "./body/SweaterDots";
import Tee1 from "./body/Tee1";
import Tee2 from "./body/Tee2";
import TeeArmsCrossed from "./body/TeeArmsCrossed";
import TeeSelena from "./body/TeeSelena";
import ThunderTShirt from "./body/ThunderTShirt";
import TShirtFemale from "./body/TShirtFemale";
import Turtleneck from "./body/Turtleneck";
import Whatever from "./body/Whatever";

import AngryWithFang from "./face/AngryWithFang";
import Awe from "./face/Awe";
import Blank from "./face/Blank";
import Calm from "./face/Calm";
import Cheeky from "./face/Cheeky";
import Concerned from "./face/Concerned";
// import ConcernedFear from "./face/ConcernedFear";
import Contempt from "./face/Contempt";
import Cute from "./face/Cute";
import Cyclops from "./face/Cyclops";
import Driven from "./face/Driven";
// import EatingHappy from "./face/EatingHappy";
import ExplainingFace from "./face/Explaining";
// import EyesClosed from "./face/EyesClosed";
import Fear from "./face/Fear";
import Hectic from "./face/Hectic";
// import LovingGrin1 from "./face/LovingGrin1";
// import LovingGrin2 from "./face/LovingGrin2";
import Monster from "./face/Monster";
import Old from "./face/Old";
import Rage from "./face/Rage";
import Serious from "./face/Serious";
import Smile from "./face/Smile";
// import SmileBig from "./face/SmileBig";
// import SmileLOL from "./face/SmileLOL";
// import SmileTeethGap from "./face/SmileTeethGap";
import Solemn from "./face/Solemn";
import Suspicious from "./face/Suspicious";
import Tired from "./face/Tired";
// import VeryAngry from "./face/VeryAngry";

import NoneFacialHair from "./facialHair/None";
import Chin from "./facialHair/Chin";
import Full from "./facialHair/Full";
import Full2 from "./facialHair/Full2";
import Full3 from "./facialHair/Full3";
import Full4 from "./facialHair/Full4";
import Goatee1 from "./facialHair/Goatee1";
import Goatee2 from "./facialHair/Goatee2";
// import Moustache1 from "./facialHair/Moustache1";
// import Moustache2 from "./facialHair/Moustache2";
// import Moustache3 from "./facialHair/Moustache3";
// import Moustache4 from "./facialHair/Moustache4";
// import Moustache5 from "./facialHair/Moustache5";
// import Moustache6 from "./facialHair/Moustache6";
// import Moustache7 from "./facialHair/Moustache7";
// import Moustache8 from "./facialHair/Moustache8";
// import Moustache9 from "./facialHair/Moustache9";

const avatarParts = {
  head: {
    Afro: Afro,
    Bangs: Bangs,
    Bangs2: Bangs2,
    BantuKnots: BantuKnots,
    Bear: Bear,
    Bun: Bun,
    Bunn: Bunn,
    Bun2: Bun2,
    Buns: Buns,
    Cornrows: Cornrows,
    Cornrows2: Cornrows2,
    // Dreads: Dreads,
    // Dreads2: Dreads2,
    FlatTop: FlatTop,
    FlatTopLong: FlatTopLong,
    GrayBun: GrayBun,
    GrayMedium: GrayMedium,
    GrayShort: GrayShort,
    HatBeanie: HatBeanie,
    HatHip: HatHip,
    Hijab: Hijab,
    Long: Long,
    // LongAfro: LongAfro,
    // LongBangs: LongBangs,
    // LongCurly: LongCurly,
    // Medium1: Medium1,
    // Medium2: Medium2,
    // Medium3: Medium3,
    // MediumBangs: MediumBangs,
    // MediumBangs2: MediumBangs2,
    // MediumBangs3: MediumBangs3,
    // MediumStraight: MediumStraight,
    Mohawk: Mohawk,
    // Mohawk2: Mohawk2,
    // NoHair1: NoHair1,
    // NoHair2: NoHair2,
    // NoHair3: NoHair3,
    Pomp: Pomp,
    // Shaved1: Shaved1,
    // Shaved2: Shaved2,
    // Shaved3: Shaved3,
    // Short1: Short1,
    // Short2: Short2,
    // Short3: Short3,
    // Short4: Short4,
    // Shortt4: Shortt4,
    // Short5: Short5,
    Turban: Turban,
    Twists: Twists,
    // Twists2: Twists2,
  },
  accessories: {
    None: NoneAccessory,
    Eyepatch: Eyepatch,
    Glasses: Glasses,
    Glasses2: Glasses2,
    Glasses3: Glasses3,
    Glasses4: Glasses4,
    Glasses5: Glasses5,
    Sunglasses: Sunglasses,
    Sunglasses2: Sunglasses2,
  },
  body: {
    BlazerBlackTee: BlazerBlackTee,
    ButtonShirt1: ButtonShirt1,
    ButtonShirt2: ButtonShirt2,
    Coffee: Coffee,
    Device: Device,
    Dress: Dress,
    Dress1: Dress1,
    TShirtFemale: TShirtFemale,
    Explaining: Explaining,
    Gaming: Gaming,
    GymShirt: GymShirt,
    Hoodie: Hoodie,
    Jacket: Jacket,
    JacketPolkaDots: JacketPolkaDots,
    Killer: Killer,
    Macbook: Macbook,
    Paper: Paper,
    PointingUp: PointingUp,
    PoloAndSweater: PoloAndSweater,
    ShirtAndCoat: ShirtAndCoat,
    SportyTee: SportyTee,
    StripedPocketTee: StripedPocketTee,
    StripedTee: StripedTee,
    Sweater: Sweater,
    SweaterDots: SweaterDots,
    Tee1: Tee1,
    Tee2: Tee2,
    TeeArmsCrossed: TeeArmsCrossed,
    TeeSelena: TeeSelena,
    ThunderTShirt: ThunderTShirt,
    Turtleneck: Turtleneck,
    Whatever: Whatever,
  },
  face: {
    AngryWithFang: AngryWithFang,
    Awe: Awe,
    Blank: Blank,
    Calm: Calm,
    Cheeky: Cheeky,
    Concerned: Concerned,
    // ConcernedFear: ConcernedFear,
    Contempt: Contempt,
    Cute: Cute,
    Cyclops: Cyclops,
    Driven: Driven,
    // EatingHappy: EatingHappy,
    ExplainingFace: ExplainingFace,
    // EyesClosed: EyesClosed,
    Fear: Fear,
    Hectic: Hectic,
    // LovingGrin1: LovingGrin1,
    // LovingGrin2: LovingGrin2,
    Monster: Monster,
    Old: Old,
    Rage: Rage,
    Serious: Serious,
    Smile: Smile,
    // SmileBig: SmileBig,
    // SmileLOL: SmileLOL,
    // SmileTeethGap: SmileTeethGap,
    Solemn: Solemn,
    Suspicious: Suspicious,
    Tired: Tired,
    // VeryAngry: VeryAngry,
  },
  facialHair: {
    None: NoneFacialHair,
    Chin: Chin,
    Full: Full,
    Full2: Full2,
    Full3: Full3,
    Full4: Full4,
    Goatee1: Goatee1,
    Goatee2: Goatee2,
    // Moustache1: Moustache1,
    // Moustache2: Moustache2,
    // Moustache3: Moustache3,
    // Moustache4: Moustache4,
    // Moustache5: Moustache5,
    // Moustache6: Moustache6,
    // Moustache7: Moustache7,
    // Moustache8: Moustache8,
    // Moustache9: Moustache9,
  },
};

export default avatarParts;
